export const config = {
  API_URL: import.meta.env.VITE_API_URL || "https://chatbot.forinsia.com",
  AUTH_TOKEN: import.meta.env.VITE_AUTH_TOKEN || "gestor_formacao_token",
};